<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script>
const defaultLayout = 'default-layout';

export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.$route.name
        ? `${this.$route.name} | ${process.env.VUE_APP_SITE_TITLE}`
        : process.env.VUE_APP_SITE_TITLE,
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout);
    },
  },
};
</script>
